module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-unknown-1.f4b66323.svg";